import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { recordPhishingClick } from '../api/api';
import Footer from '../components/Footer';

function Check({ done }) {
  return (
    <span className={done ? 'text-cyan-500 dark:text-cyan-400' : 'text-slate-500 dark:text-slate-400'}>
      {done ? '✔' : '○'}
    </span>
  );
}

export default function PhishingTestResult() {
  const { token } = useParams();
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!token) {
      setError('Link inválido');
      setLoading(false);
      return;
    }
    recordPhishingClick(token)
      .then(setResult)
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, [token]);

  if (loading) {
    return (
      <div className="min-h-screen flex flex-col bg-[#F8FAFC] dark:bg-slate-900 text-slate-900 dark:text-slate-100">
        <div className="flex-1 flex items-center justify-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-cyan-500" />
        </div>
        <Footer />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex flex-col bg-[#F8FAFC] dark:bg-slate-900 text-slate-900 dark:text-slate-100">
        <div className="flex-1 flex items-center justify-center px-4">
          <div className="bg-white dark:bg-slate-800 rounded-xl shadow p-8 max-w-md text-center border border-slate-200 dark:border-slate-700">
            <h1 className="text-xl font-bold text-slate-900 dark:text-slate-100 mb-2">Link inválido</h1>
            <p className="text-slate-500 dark:text-slate-400">{error}</p>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col bg-[#F8FAFC] dark:bg-slate-900 text-slate-900 dark:text-slate-100">
      <div className="flex-1 flex items-center justify-center px-4 py-12">
        <div className="bg-white dark:bg-slate-800 rounded-xl shadow-lg p-8 max-w-lg w-full border border-slate-200 dark:border-slate-700">
          <h1 className="text-2xl font-bold text-slate-900 dark:text-slate-100 mb-6 text-center">
            Resultado da Simulação de Phishing
          </h1>

          <div className="space-y-4 mb-8 text-slate-700 dark:text-slate-300">
            <p className="flex items-center gap-3">
              <Check done={result?.sentAt} />
              <span>E-mail enviado</span>
            </p>
            <p className="flex items-center gap-3">
              <Check done={result?.opened} />
              <span>E-mail aberto</span>
            </p>
            <p className="flex items-center gap-3">
              <Check done={result?.clicked} />
              <span>Link clicado</span>
            </p>
          </div>

          <div className="bg-cyan-50 dark:bg-cyan-500/15 border border-cyan-200 dark:border-cyan-500/30 rounded-lg p-4 mb-6">
            <h2 className="font-semibold text-cyan-700 dark:text-cyan-400 mb-2">Esta era uma simulação de segurança</h2>
            <p className="text-cyan-800/90 dark:text-cyan-400/90 text-sm">
              O e-mail que você recebeu fazia parte de um teste de conscientização. Em um ataque real
              de phishing, ao clicar no link e inserir suas credenciais, criminosos poderiam roubá-las e
              acessar suas contas. Sempre verifique o remetente e a URL antes de informar dados sensíveis.
            </p>
          </div>

          <p className="text-center text-slate-500 dark:text-slate-400 text-sm">
            Obrigado por participar da simulação de segurança.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}
